import { render } from "./BlockUserMenu.vue?vue&type=template&id=6163f0a4&scoped=true"
import script from "./BlockUserMenu.vue?vue&type=script&lang=js"
export * from "./BlockUserMenu.vue?vue&type=script&lang=js"

import "./BlockUserMenu.vue?vue&type=style&index=0&id=6163f0a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6163f0a4"]])

export default __exports__